module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-26.1f3e2f7d.png";